import { AxiosResponse } from 'axios';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ResponseBase } from 'src/app/models/response-base';
import { CollaboratorRequest } from '../../models/collaborator/collaborator-request.model';
import { CollaboratorResponse } from '../../models/collaborator/collaborator-response.model';
import { Paged } from '../../models/paged.model';
import { CollaboratorsValue, ValuesProducts, ValuesPurchaseRequest } from '../../models/purchase/values-purchase-request.model';
import { api } from '../../services/api';
import { COLLABORATOR_LIST, COLLABORATOR_LIST_VALUES, EDIT_COLLABORATOR_VALUE, RESET_PURCHASE_COLLABORATOR } from '../contants';
import store from '../store';
import { editCollaboratorValueError, editCollaboratorValueSuccess, getCollaboratorsError, getCollaboratorsSuccess, getCollaboratorsValuesError, getCollaboratorsValuesSuccess, resetPurchaseCollaboratorError, resetPurchaseCollaboratorSuccess } from './actions';

type fetchCollaboratorsPayload = { assignorGuid: string, managerGuid: string, limit: number, page: number, collaboratorRequest: CollaboratorRequest, groupId?: number }
type fetchCollaboratorsParams = { payload: fetchCollaboratorsPayload, type: string };

type fetchCollaboratorsValuesParams = { payload: fetchCollaboratorsValuesPayload, type: string };
type fetchCollaboratorsValuesPayload = { assignorGuid: string, managerGuid: string, limit: number, page: number, productId: number, purchaseId: number }

type editCollaboratorValueParams = { payload: editCollaboratorValuePayload, type: string };
type editCollaboratorValuePayload = { productId: number, collaboratorId: number, providedValue: number }

export function* watchResetPurchaseCollaborator() {
  yield takeEvery(RESET_PURCHASE_COLLABORATOR, resetPurchaseCollaborator);
}

function* resetPurchaseCollaborator() {
  try {
    yield put(resetPurchaseCollaboratorSuccess());
  } catch (error) {
    yield put(resetPurchaseCollaboratorError(error));
  }
}


export function* watchFetchCollaborators() {
  yield takeEvery(COLLABORATOR_LIST, fetchCollaborators);
}

const fetchCollaboratorsAsync = async (assignorGuid: string, managerGuid: string, params: any, collaboratorRequest: CollaboratorRequest) =>
  await api.post(`purchases/assignors/${assignorGuid}/managers/${managerGuid}/collaborators`, collaboratorRequest, { params })
    .then((response: any) => response)
    .catch((error: any) => error);


function* fetchCollaborators({ payload }: fetchCollaboratorsParams) {
  try {
    const { assignorGuid, managerGuid, limit, page, collaboratorRequest, groupId } = payload;
    const params = new URLSearchParams(
      [
        ['limit', limit.toString() ],
        ['page', page.toString() ],
      ]
    );
    if(groupId)
      params.append('groupId', groupId.toString());
      
    const response: AxiosResponse<ResponseBase<Paged<CollaboratorResponse>>> = yield call(fetchCollaboratorsAsync, assignorGuid, managerGuid, params, collaboratorRequest);

    if (response?.data?.status == 1) {
      yield put(getCollaboratorsSuccess(response?.data?.result));
    } else {
      yield put(getCollaboratorsError(response?.data?.message));
    }
  } catch (error) {
    yield put(getCollaboratorsError(error));
  }
}



export function* watchFetchCollaboratorsValues() {
  yield takeEvery(COLLABORATOR_LIST_VALUES, fetchCollaboratorsValues);
}

const fetchCollaboratorsValuesAsync = async (assignorGuid: string, managerGuid: string,  params: any) =>
  await api.post(`purchases/assignors/${assignorGuid}/managers/${managerGuid}/values`, null, { params })
    .then((response: any) => response)
    .catch((error: any) => error);

function* fetchCollaboratorsValues({ payload }: fetchCollaboratorsValuesParams) {
  try {
    const { assignorGuid, managerGuid, limit, page, productId, purchaseId } = payload;
    const { editedCollaborators } = store.getState().collaborator;

    const params = new URLSearchParams(
      [
        ['limit', limit.toString() ],
        ['page', page.toString() ],
        ['productId', productId.toString() ],
        ['purchaseId', purchaseId.toString() ]
      ]
    );
    const response: AxiosResponse<ResponseBase<Paged<CollaboratorResponse>>> = yield call(fetchCollaboratorsValuesAsync, assignorGuid, managerGuid, params);
    const hasEditedCollaborators = editedCollaborators?.products?.find(x=>x.productId === productId)
    let oldValue = 0;

    if (response?.data?.status == 1) {

      response.data.result.items = response.data.result.items.map((item, index, arr) => {
        let obj = {};
        if(hasEditedCollaborators){
            const isUpdated = hasEditedCollaborators.collaboratorValues.find(x=>x.collaboratorId === item.collaboratorId);
            if(isUpdated){
                item.standardValue = isUpdated.value;
                oldValue = oldValue + isUpdated.value;
            }else {
              oldValue = oldValue + item.standardValue;
            }
        }else{
          oldValue = oldValue + item.standardValue;
        }
        obj['providedValue'] = item.standardValue;

        return Object.assign({}, item, obj);
      })

      yield put(getCollaboratorsValuesSuccess(response?.data?.result, oldValue));
    } else {
      yield put(getCollaboratorsValuesError(response?.data?.message));
    }
  } catch (error) {
    yield put(getCollaboratorsValuesError(error));
  }
}

export function* watchEditCollaboratorValue() {
  yield takeEvery(EDIT_COLLABORATOR_VALUE, editCollaboratorValue);
}

function* editCollaboratorValue({ payload }: editCollaboratorValueParams) {
  try {
    const { productId, collaboratorId, providedValue } = payload;
    const { collaborators, editedCollaborators } = store.getState().collaborator;
    const response: any = collaborators;
    const valuesPurchaseRequest: ValuesPurchaseRequest = {
      purchaseId: 0,
      products: []
    };

    const updateValuesProducts: ValuesPurchaseRequest  = editedCollaborators;
    const selectedProductValues = updateValuesProducts?.products?.find(x=>x.productId == productId);

    if(selectedProductValues){
      response.items = collaborators.items.map((item, index, arr) => {
        if (arr[index].collaboratorId === collaboratorId) {
          let obj = {};
          obj['standardValue'] = providedValue;
          obj['providedValue'] = providedValue;

          const isUpdated = selectedProductValues.collaboratorValues.find(x=>x.collaboratorId === collaboratorId);

          if(isUpdated){
            isUpdated.value = providedValue;
          }
          if(!isUpdated){
            const collaboratorValue: CollaboratorsValue = {
              collaboratorId: collaboratorId,
              value: providedValue
            };
            selectedProductValues.collaboratorValues.push(collaboratorValue);
          }

          return Object.assign({}, item, obj);
        }
        return item;
      })

      if(updateValuesProducts){
        updateValuesProducts.products.find(x=>x.productId == productId).collaboratorValues = selectedProductValues.collaboratorValues;
      }

    }
    else{
      const collaboratorValues: CollaboratorsValue[] = [];
      response.items = collaborators.items.map((item, index, arr) => {
        if (arr[index].collaboratorId === collaboratorId) {
          let obj = {};
          obj['standardValue'] = providedValue;
          obj['providedValue'] = providedValue;

          const collaboratorValue: CollaboratorsValue = {
            collaboratorId: collaboratorId,
            value: providedValue
          };
          collaboratorValues.push(collaboratorValue);

          return Object.assign({}, item, obj);
        }
        return item;
      })

      const valuesProducts: ValuesProducts = {
        productId: productId,
        collaboratorValues: collaboratorValues
      }

      if(!updateValuesProducts){
        valuesPurchaseRequest.products.push(valuesProducts);
      }
      if(updateValuesProducts){
        updateValuesProducts.products.push(valuesProducts);
      }
    }

    if(updateValuesProducts){
      valuesPurchaseRequest.products = updateValuesProducts.products;
    }

    if (response || valuesPurchaseRequest) {
      yield put(editCollaboratorValueSuccess(response, valuesPurchaseRequest));
    } else {
      yield put(editCollaboratorValueError(response));
    }
  } catch (error) {
    yield put(editCollaboratorValueError(error));
  }
}



export default function* rootSaga() {
  yield all([
    fork(watchFetchCollaborators),
    fork(watchFetchCollaboratorsValues),
    fork(watchEditCollaboratorValue),
    fork(watchResetPurchaseCollaborator),
  ]);
}
